import { ArsenalUnitStep, PaintStep } from '@Models';
import { ArsenalStepView } from '@Selectors/arsenal/make/view/ArsenalStepView';
import { getAllEnumValues } from 'enum-for';

export const createSteps = (steps: ArsenalUnitStep[]): ArsenalStepView[] => {
  const total = Math.max(
    steps.reduce((acc, step) => acc + step.size, 0),
    1,
  );
  return getAllEnumValues(PaintStep).map((value) => {
    const item = steps.find((s) => s.step === value);
    return {
      id: item?.id ?? '',
      step: value,
      name: PaintStep[value],
      color: stepToColor(value),
      value: item?.size ?? 0,
      pourcentage: Math.round(((item?.size ?? 0) * 100000) / total) / 1000,
    } satisfies ArsenalStepView as ArsenalStepView;
  });
};

export const stepToColor = (step: PaintStep): string => {
  switch (step) {
    case PaintStep.Project:
      return '#cd1c00';
    case PaintStep.Bought:
      return '#ff5500';
    case PaintStep.Unassembled:
      return '#ff9600';
    case PaintStep.Assembled:
      return '#ffb233';
    case PaintStep.Primed:
      return '#ffcd00';
    case PaintStep.Painted:
      return '#30c858';
    case PaintStep.Based:
      return '#178d5e';
    default:
      return '';
  }
};
